/**
 * Phase 3 - Korean translations module
 */
import enBase from './en.js';
import { translationsKo } from '../../utils/translations/translations.ko.js';
import { plansTranslationsKo } from '../../utils/translations/plans/plansTranslations.ko.js';

const merged = { ...enBase, ...translationsKo, ...plansTranslationsKo };
export default merged;
